<template>
  <v-container>
    <ViewsContainer
      :moduleName="moduleName"
      :listViewComponent="Table"
      :filterComponent="Filter"
      :data="data"
      :config="'@/components/modules/influencers/influencers.config'"
      :onCreate="create"
      :onUpdate="update"
      :onDelete="remove"
      :exportCsv="exportCsv"
      :show_toolbar="true"
      :show_pagination="true"
      :title="{singular:'Influencer', plural:'Influencers'}"
      :key="moduleName"
    />
  </v-container>
</template>

<script lang="ts" setup>
import { onMounted, computed } from 'vue';
import { usePreferencesStore } from '@/store/preferences';
import { useInfluencersStore } from '@/store/influencers';
import { useModuleLayoutFetcher } from '@/composables/useModuleLayoutFetcher';
import { HEADERS, DEFAULT_HEADER_ORDER } from '@/components/modules/influencers/influencers.config';

import Table from '@/components/views/TableView.vue';
import Filter from '@/components/drawer/Filters.vue';
import ViewsContainer from '@/components/views/ViewsContainer.vue';

const moduleName = 'Influencers';
const preferencesStore = usePreferencesStore();
const influencersStore = useInfluencersStore();

const {
  create,
  update,
  remove,
  exportCsv
} = useModuleLayoutFetcher(
  moduleName,
  (params) => influencersStore.fetchInfluencers(params),
  {
    create: influencersStore.createInfluencer,
    update: (data) => influencersStore.updateInfluencer(data.id, data),
    remove: influencersStore.deleteInfluencer,
    exportCsv: () => Promise.resolve()
  }
);

onMounted(() => {
  preferencesStore.currentModule = moduleName;
  preferencesStore.setAllModuleHeaders(moduleName, HEADERS);
  preferencesStore.setDefaultModuleHeaders(
    moduleName,
    DEFAULT_HEADER_ORDER
      .map(value => HEADERS.find(header => header.value === value))
      .filter(Boolean) as typeof HEADERS
  );
});

const data = computed(() => influencersStore.influencers);
</script>
